import CardItem from './CardItem'

const CardSection = function ({
  title,
  description,
  linkButton,
  textButton,
  url,
  newTab,
  showButton = false,
  showCardImage,
}) {
  return (
    <div className="container">
      <div className="row d-flex justify-content-center align-items-center">
        {showCardImage && (
          <div className="col-lg-6 col-12">
            <CardItem url={url} />
          </div>
        )}
        <div className="col-lg-6 col-12 mt-5">
          <p
            style={{
              fontWeight: 'bold',
              fontSize: '24px',
              lineHeight: '36px',
              color: 'rgb(133, 113, 77)',
              textAlign: 'center',
            }}
          >
            {title}
          </p>
          <p
            className="mb-3 mb-lg-4"
            style={{
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontSize: '14px',
              lineHeight: '20px',
              color: 'rgb(94, 81, 77)',
              textAlign: 'justify',
            }}
          >
            {description}
          </p>
          {showButton && (
            <div className="d-grid mb-5">
              <a
                href={linkButton}
                type="button"
                className="btn btn-primary btn-lg text-center"
                target={newTab === 'true' ? '_blank' : '_self'}
                rel={newTab === 'true' ? 'noreferrer' : ''}
              >
                {textButton}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CardSection
